// AUTO-GENERATED — Localizações Portugal
// Distritos com freguesias completas (oficial CAOP/geoapi.pt): Aveiro, Beja, Braga, Coimbra, Leiria, Faro
// Restantes distritos: apenas concelhos (freguesias podem ser adicionadas posteriormente)
//
// Ordenado alfabeticamente. Format: { distrito: { concelho: [freguesias] } }

export const LOC_PT = {
  "Aveiro": {
    "Albergaria-a-velha": [
      "Albergaria-a-Velha e Valmaior",
      "Alquerubim",
      "Angeja",
      "Branca",
      "Ribeira de Fráguas",
      "São João de Loure e Frossos"
    ],
    "Anadia": [
      "Avelãs de Caminho",
      "Avelãs de Cima",
      "Moita",
      "Sangalhos",
      "São Lourenço do Bairro",
      "União das freguesias de Amoreira da Gândara, Paredes do Bairro e Ancas",
      "União das freguesias de Arcos e Mogofores",
      "União das freguesias de Tamengos, Aguim e Óis do Bairro",
      "Vila Nova de Monsarros",
      "Vilarinho do Bairro"
    ],
    "Arouca": [
      "Alvarenga",
      "Chave",
      "Escariz",
      "Fermedo",
      "Mansores",
      "Moldes",
      "Rossas",
      "Santa Eulália",
      "São Miguel do Mato",
      "Tropeço",
      "União das freguesias de Arouca e Burgo",
      "União das freguesias de Cabreiros e Albergaria da Serra",
      "União das freguesias de Canelas e Espiunca",
      "União das freguesias de Covelo de Paivó e Janarde",
      "Urrô",
      "Várzea"
    ],
    "Aveiro": [
      "Aradas",
      "Cacia",
      "Eixo e Eirol",
      "Esgueira",
      "Oliveirinha",
      "Requeixo, Nossa Senhora de Fátima e Nariz",
      "Santa Joana",
      "São Bernardo",
      "São Jacinto",
      "União das freguesias de Glória e Vera Cruz"
    ],
    "Castelo de Paiva": [
      "Bairros",
      "Fornos",
      "Paraíso",
      "Pedorido",
      "Raiva",
      "Real",
      "Santa Maria de Sardoura",
      "Sobrado",
      "São Martinho de Sardoura"
    ],
    "Espinho": [
      "Anta",
      "Espinho",
      "Guetim",
      "Paramos",
      "Silvalde"
    ],
    "Estarreja": [
      "Avanca",
      "Beduído",
      "Pardilhó",
      "Salreu",
      "União das freguesias de Canelas e Fermelã",
      "Veiros"
    ],
    "Mealhada": [
      "Antes",
      "Barcouço",
      "Casal Comba",
      "Luso",
      "Mealhada",
      "Pampilhosa",
      "Vacariça",
      "Ventosa do Bairro"
    ],
    "Murtosa": [
      "Bunheiro",
      "Monte",
      "Murtosa",
      "Torreira"
    ],
    "Oliveira de Azeméis": [
      "Carregosa",
      "Cesar",
      "Fajões",
      "Loureiro",
      "Macieira de Sarnes",
      "Nogueira do Cravo",
      "Ossela",
      "Pindelo",
      "São Martinho da Gândara",
      "São Roque",
      "União das freguesias de Oliveira de Azeméis, Santiago de Riba-Ul, Ul, Macinhata da Seixa e Madail",
      "União das freguesias de Pinheiro da Bemposta, Travanca e Palmaz",
      "Vila de Cucujães"
    ],
    "Oliveira do Bairro": [
      "Oiã",
      "Oliveira do Bairro",
      "Palhaça",
      "União das freguesias de Bustos, Troviscal e Mamarrosa"
    ],
    "Ovar": [
      "Arada",
      "Cortegaça",
      "Esmoriz",
      "Maceda",
      "Ovar",
      "São João",
      "São Vicente de Pereira Jusã",
      "Válega"
    ],
    "Santa Maria da Feira": [
      "Argoncilhe",
      "Arrifana",
      "Caldas de São Jorge",
      "Canedo",
      "Escapães",
      "Fiães",
      "Fornos",
      "Gião",
      "Guisande",
      "Lobão",
      "Louredo",
      "Lourosa",
      "Milheirós de Poiares",
      "Mosteirô",
      "Mozelos",
      "Nogueira da Regedoura",
      "Paços de Brandão",
      "Pigeiros",
      "Rio Meão",
      "Romariz",
      "Sanguedo",
      "Santa Maria de Lamas",
      "São João de Ver",
      "São Miguel de Souto",
      "São Paio de Oleiros",
      "União das freguesias de Santa Maria da Feira, Travanca, Sanfins e Espargo",
      "Vale",
      "Vila Maior"
    ],
    "Sever do Vouga": [
      "Cedrim",
      "Couto de Esteves",
      "Dornelas",
      "Paradela",
      "Pessegueiro do Vouga",
      "Rocas do Vouga",
      "Sever do Vouga",
      "Silva Escura",
      "Talhadas"
    ],
    "São João da Madeira": [
      "São João da Madeira"
    ],
    "Vagos": [
      "Calvão",
      "Covão do Lobo",
      "Fonte de Angeão",
      "Gafanha da Boa Hora",
      "Ouca",
      "Ponte de Vagos",
      "Santa Catarina",
      "Santo André de Vagos",
      "Santo António",
      "Sosa",
      "Vagos"
    ],
    "Vale de Cambra": [
      "Arões",
      "Cepelos",
      "Junqueira",
      "Macieira de Cambra",
      "Roge",
      "São Pedro de Castelões",
      "União das freguesias de Vila Chã, Codal e Vila Cova de Perrinho"
    ],
    "Águeda": [
      "Agadão",
      "Aguada de Baixo",
      "Aguada de Cima",
      "Barrô",
      "Belazaima do Chão",
      "Borralha",
      "Castanheira do Vouga",
      "Fermentelos",
      "Macinhata do Vouga",
      "União das freguesias de Recardães e Espinhel",
      "União das freguesias de Travassô e Óis da Ribeira",
      "União das freguesias de Trofa, Segadães e Lamas do Vouga",
      "União das freguesias do Préstimo e Macieira de Alcoba",
      "Valongo do Vouga",
      "Águeda"
    ],
    "Ílhavo": [
      "Gafanha da Encarnação",
      "Gafanha da Nazaré",
      "Gafanha do Carmo",
      "Ílhavo (São Salvador)"
    ]
  },
  "Açores": {
    "Angra do Heroísmo": [],
    "Calheta de São Jorge": [],
    "Corvo": [],
    "Horta": [],
    "Lagoa (Açores)": [],
    "Lajes das Flores": [],
    "Lajes do Pico": [],
    "Madalena": [],
    "Nordeste": [],
    "Ponta Delgada": [],
    "Povoação": [],
    "Praia da Vitória": [],
    "Ribeira Grande": [],
    "Santa Cruz da Graciosa": [],
    "Santa Cruz das Flores": [],
    "São Roque do Pico": [],
    "Velas": [],
    "Vila Franca do Campo": [],
    "Vila do Porto": []
  },
  "Beja": {
    "Aljustrel": [
      "Aljustrel",
      "Ervidel",
      "Messejana",
      "Rio de Moinhos",
      "São João de Negrilhos"
    ],
    "Almodôvar": [
      "Aldeia dos Fernandes",
      "Almodôvar",
      "Gomes Aires",
      "Rosário",
      "Santa Clara-a-Nova",
      "Santa Cruz",
      "Senhora da Graça dos Padrões",
      "São Barnabé"
    ],
    "Alvito": [
      "Alvito",
      "Vila Nova da Baronia"
    ],
    "Barrancos": [
      "Barrancos"
    ],
    "Beja": [
      "Baleizão",
      "Beringel",
      "Cabeça Gorda",
      "Nossa Senhora das Neves",
      "Santa Clara de Louredo",
      "São Matias",
      "União das freguesias de Albernoa e Trindade",
      "União das freguesias de Beja (Salvador e Santa Maria da Feira)",
      "União das freguesias de Beja (Santiago Maior e São João Baptista)",
      "União das freguesias de Salvada e Quintos",
      "União das freguesias de Santa Vitória e Mombeja",
      "União das freguesias de Trigaches e São Brissos"
    ],
    "Castro Verde": [
      "Entradas",
      "Santa Bárbara de Padrões",
      "São Marcos da Ataboeira",
      "União das freguesias de Castro Verde e Casével"
    ],
    "Cuba": [
      "Cuba",
      "Faro do Alentejo",
      "Vila Alva",
      "Vila Ruiva"
    ],
    "Ferreira do Alentejo": [
      "Alfundão",
      "Canhestros",
      "Ferreira do Alentejo",
      "Figueira dos Cavaleiros",
      "Odivelas",
      "Peroguarda"
    ],
    "Moura": [
      "Amareleja",
      "Póvoa de São Miguel",
      "Safara",
      "Santo Aleixo da Restauração",
      "Sobral da Adiça",
      "União das freguesias de Moura (Santo Agostinho e São João Baptista) e Santo Amador"
    ],
    "Mértola": [
      "Alcaria Ruiva",
      "Corte do Pinto",
      "Espírito Santo",
      "Mértola",
      "Santana de Cambas",
      "São João dos Caldeireiros",
      "União das freguesias de São Miguel do Pinheiro, São Pedro de Solis e São Sebastião dos Carros"
    ],
    "Odemira": [
      "Bicos",
      "Boavista dos Pinheiros",
      "Colos",
      "Longueira/Almograve",
      "Luzianes-Gare",
      "Relíquias",
      "Sabóia",
      "Santa Clara-a-Velha",
      "São Luís",
      "São Martinho das Amoreiras",
      "São Salvador e Santa Maria",
      "São Teotónio",
      "Vale de Santiago",
      "Vila Nova de Milfontes"
    ],
    "Ourique": [
      "Garvão",
      "Ourique",
      "Santa Luzia",
      "Santana da Serra",
      "União das freguesias de Panoias e Conceição"
    ],
    "Serpa": [
      "Brinches",
      "Pias",
      "União das freguesias de Serpa (Salvador e Santa Maria)",
      "Vale de Vargo",
      "Vila Nova de São Bento",
      "Vila Verde de Ficalho"
    ],
    "Vidigueira": [
      "Pedrógão",
      "Selmes",
      "Vidigueira",
      "Vila de Frades"
    ]
  },
  "Braga": {
    "Amares": [
      "Barreiros",
      "Bico",
      "Bouro (Santa Maria)",
      "Bouro (Santa Marta)",
      "Caires",
      "Carrazedo",
      "Dornelas",
      "Fiscal",
      "Goães",
      "Lago",
      "Rendufe",
      "União das freguesias de Amares e Figueiredo",
      "União das freguesias de Caldelas, Sequeiros e Paranhos",
      "União das freguesias de Ferreiros, Prozelo e Besteiros",
      "União das freguesias de Torre e Portela",
      "União das freguesias de Vilela, Seramil e Paredes Secas"
    ],
    "Barcelos": [
      "Abade de Neiva",
      "Aborim",
      "Adães",
      "Airó",
      "Aldreu",
      "Alvelos",
      "Arcozelo",
      "Areias",
      "Balugães",
      "Barcelinhos",
      "Barcelos",
      "Barqueiros",
      "Cambeses",
      "Carapeços",
      "Carvalhal",
      "Carvalhas",
      "Cossourado",
      "Cristelo",
      "Fornelos",
      "Fragoso",
      "Galegos (Santa Maria)",
      "Galegos (São Martinho)",
      "Gilmonde",
      "Lama",
      "Lijó",
      "Macieira de Rates",
      "Manhente",
      "Martim",
      "Moure",
      "Oliveira",
      "Palme",
      "Panque",
      "Paradela",
      "Pereira",
      "Perelhal",
      "Pousa",
      "Remelhe",
      "Rio Covo (Santa Eugénia)",
      "Rio Covo (Santa Eulália)",
      "Roriz",
      "Silva",
      "Silveiros",
      "Tamel (São Veríssimo)",
      "Ucha",
      "União das freguesias de Alheira e Igreja Nova",
      "União das freguesias de Alvito (São Pedro e São Martinho) e Couto",
      "União das freguesias de Areias de Vilar e Encourados",
      "União das freguesias de Campo e Tamel (São Pedro Fins)",
      "União das freguesias de Carreira e Fonte Coberta",
      "União das freguesias de Chorente, Góios, Courel, Pedra Furada e Gueral",
      "União das freguesias de Creixomil e Mariz",
      "União das freguesias de Durrães e Tregosa",
      "União das freguesias de Gamil e Midões",
      "União das freguesias de Milhazes, Vilar de Figos e Faria",
      "União das freguesias de Negreiros e Chavão",
      "União das freguesias de Quintiães e Aguiar",
      "União das freguesias de Sequeade e Bastuço (São João e Santo Estevão)",
      "União das freguesias de Tamel (Santa Leocádia) e Vilar do Monte",
      "União das freguesias de Viatodos, Grimancelos, Minhotães e Monte de Fralães",
      "União das freguesias de Vila Cova e Feitos",
      "Vila Boa",
      "Vila Frescainha (São Martinho)",
      "Vila Frescainha (São Pedro)",
      "Vila Seca",
      "Várzea"
    ],
    "Braga": [
      "Adaúfe",
      "Braga (São Vicente)",
      "Braga (São Vítor)",
      "Espinho",
      "Esporões",
      "Figueiredo",
      "Gualtar",
      "Lamas",
      "Mire de Tibães",
      "Padim da Graça",
      "Palmeira",
      "Pedralva",
      "Priscos",
      "Ruilhe",
      "Sequeira",
      "Sobreposta",
      "Tadim",
      "Tebosa",
      "União das freguesias de Arentim e Cunha",
      "União das freguesias de Braga (Maximinos, Sé e Cividade)",
      "União das freguesias de Braga (São José de São Lázaro e São João do Souto)",
      "União das freguesias de Cabreiros e Passos (São Julião)",
      "União das freguesias de Celeirós, Aveleda e Vimieiro",
      "União das freguesias de Crespos e Pousada",
      "União das freguesias de Escudeiros e Penso (Santo Estêvão e São Vicente)",
      "União das freguesias de Este (São Pedro e São Mamede)",
      "União das freguesias de Ferreiros e Gondizalves",
      "União das freguesias de Guisande e Oliveira (São Pedro)",
      "União das freguesias de Lomar e Arcos",
      "União das freguesias de Merelim (São Paio), Panoias e Parada de Tibães",
      "União das freguesias de Merelim (São Pedro) e Frossos",
      "União das freguesias de Morreira e Trandeiras",
      "União das freguesias de Nogueira, Fraião e Lamaçães",
      "União das freguesias de Nogueiró e Tenões",
      "União das freguesias de Real, Dume e Semelhe",
      "União das freguesias de Santa Lucrécia de Algeriz e Navarra",
      "União das freguesias de Vilaça e Fradelos"
    ],
    "Cabeceiras de Basto": [
      "Abadim",
      "Basto",
      "Bucos",
      "Cabeceiras de Basto",
      "Cavez",
      "Faia",
      "Outeiro",
      "Painzela",
      "Pedraça",
      "Refojos de Basto",
      "Rio Douro",
      "União das freguesias de Alvite e Passos",
      "União das freguesias de Arco de Baúlhe e Vila Nune",
      "União das freguesias de Gondiães e Vilar de Cunhas"
    ],
    "Celorico de Basto": [
      "Agilde",
      "Arnóia",
      "Basto (São Clemente)",
      "Borba de Montanha",
      "Codeçoso",
      "Fervença",
      "Moreira do Castelo",
      "Rego",
      "Ribas",
      "União das freguesias de Britelo, Gémeos e Ourilhe",
      "União das freguesias de Canedo de Basto e Corgo",
      "União das freguesias de Carvalho e Basto (Santa Tecla)",
      "União das freguesias de Caçarilhe e Infesta",
      "União das freguesias de Veade, Gagos e Molares",
      "Vale de Bouro"
    ],
    "Esposende": [
      "Antas",
      "Apúlia",
      "Belinho",
      "Curvos",
      "Esposende",
      "Forjães",
      "Fão",
      "Gandra",
      "Gemeses",
      "Mar",
      "Marinhas",
      "Palmeira de Faro",
      "União das freguesias de Fonte Boa e Rio Tinto",
      "Vila Chã"
    ],
    "Fafe": [
      "Armil",
      "Arões (Santa Cristina)",
      "Arões (São Romão)",
      "Estorãos",
      "Fafe",
      "Fornelos",
      "Golães",
      "Medelo",
      "Paços",
      "Quinchães",
      "Regadas",
      "Revelhe",
      "Ribeiros",
      "Silvares (São Martinho)",
      "São Gens",
      "Travassós",
      "União de freguesias de Aboim, Felgueiras, Gontim e Pedraído",
      "União de freguesias de Agrela e Serafão",
      "União de freguesias de Antime e Silvares (São Clemente)",
      "União de freguesias de Ardegão, Arnozela e Seidões",
      "União de freguesias de Cepães e Fareja",
      "União de freguesias de Freitas e Vila Cova",
      "União de freguesias de Monte e Queimadela",
      "União de freguesias de Moreira do Rei e Várzea Cova",
      "Vinhós"
    ],
    "Guimarães": [
      "Airão (Santa Maria)",
      "Airão São João ",
      "Aldão",
      "Azurém",
      "Barco",
      "Brito",
      "Caldelas",
      "Calvos",
      "Candoso (São Martinho)",
      "Conde",
      "Corvite",
      "Costa",
      "Creixomil",
      "Fermentões",
      "Gandarela",
      "Gondar",
      "Gonça",
      "Guardizela",
      "Infantas",
      "Longos",
      "Lordelo",
      "Mesão Frio",
      "Moreira de Cónegos",
      "Nespereira",
      "Pencelo",
      "Pinheiro",
      "Polvoreira",
      "Ponte",
      "Prazins (Santa Eufémia)",
      "Prazins Santo Tirso",
      "Ronfe",
      "Sande (São Clemente)",
      "Sande (São Martinho)",
      "Sande (Vila Nova)",
      "Selho (São Cristóvão)",
      "Selho (São Jorge)",
      "Serzedelo",
      "Serzedo",
      "Silvares",
      "São Faustino",
      "São Torcato",
      "Tabuadelo",
      "União das freguesias de Abação e Gémeos",
      "União das freguesias de Arosa e Castelões",
      "União das freguesias de Atães e Rendufe",
      "União das freguesias de Briteiros Santo Estêvão e Donim",
      "União das freguesias de Briteiros São Salvador e Briteiros Santa Leocádia",
      "União das freguesias de Candoso São Tiago e Mascotelos",
      "União das freguesias de Leitões, Oleiros e Figueiredo",
      "União das freguesias de Oliveira, São Paio e São Sebastião",
      "União das freguesias de Sande São Lourenço e Balazar",
      "União das freguesias de Selho São Lourenço e Gominhães",
      "União das freguesias de Souto Santa Maria, Souto São Salvador e Gondomar",
      "Urgezes",
      "Vermil"
    ],
    "Póvoa de Lanhoso": [
      "Covelas",
      "Ferreiros",
      "Galegos",
      "Garfe",
      "Geraz do Minho",
      "Lanhoso",
      "Monsul",
      "Póvoa de Lanhoso (Nossa Senhora do Amparo)",
      "Rendufinho",
      "Santo Emilião",
      "Serzedelo",
      "Sobradelo da Goma",
      "São João de Rei",
      "Taíde",
      "Travassos",
      "União das freguesias de Calvos e Frades",
      "União das freguesias de Campos e Louredo",
      "União das freguesias de Esperança e Brunhais",
      "União das freguesias de Fonte Arcada e Oliveira",
      "União das freguesias de Verim, Friande e Ajude",
      "União das freguesias de Águas Santas e Moure",
      "Vilela"
    ],
    "Terras de Bouro": [
      "Balança",
      "Campo do Gerês",
      "Carvalheira",
      "Covide",
      "Gondoriz",
      "Moimenta",
      "Ribeira",
      "Rio Caldo",
      "Souto",
      "União das freguesias de Chamoim e Vilar",
      "União das freguesias de Chorense e Monte",
      "União das freguesias de Cibões e Brufe",
      "Valdosende",
      "Vilar da Veiga"
    ],
    "Vieira do Minho": [
      "Cantelães",
      "Eira Vedra",
      "Guilhofrei",
      "Louredo",
      "Mosteiro",
      "Parada de Bouro",
      "Pinheiro",
      "Rossas",
      "Salamonde",
      "Tabuaças",
      "União das freguesias de Anissó e Soutelo",
      "União das freguesias de Anjos e Vilar do Chão",
      "União das freguesias de Caniçada e Soengas",
      "União das freguesias de Ruivães e Campos",
      "União das freguesias de Ventosa e Cova",
      "Vieira do Minho"
    ],
    "Vila Nova de Famalicão": [
      "Avidos",
      "Bairro",
      "Brufe",
      "Cabeçudos",
      "Castelões",
      "Cavalões",
      "Cruz",
      "Delães",
      "Esmeriz",
      "Fradelos",
      "Gavião",
      "Gondifelos",
      "Joane",
      "Lagoa",
      "Landim",
      "Louro",
      "Lousado",
      "Mogege",
      "Nine",
      "Novais",
      "Oliveira (Santa Maria)",
      "Oliveira (São Mateus)",
      "Outiz",
      "Pedome",
      "Pousada de Saramagos",
      "Requião",
      "Riba de Ave",
      "Ribeirão",
      "Ruivães",
      "União das freguesias de Antas e Abade de Vermoim",
      "União das freguesias de Arnoso (Santa Maria e Santa Eulália) e Sezures",
      "União das freguesias de Carreira e Bente",
      "União das freguesias de Lemenhe, Mouquim e Jesufrei",
      "União das freguesias de Seide",
      "União das freguesias de Vale (São Cosme), Telhado e Portela",
      "União das freguesias de Vila Nova de Famalicão e Calendário",
      "Vale (São Martinho)",
      "Vermoim",
      "Vilarinho das Cambas"
    ],
    "Vila Verde": [
      "Aboim da Nóbrega e Gondomar",
      "Atiães",
      "Cabanelas",
      "Cervães",
      "Coucieiro",
      "Dossãos",
      "Freiriz",
      "Gême",
      "Lage",
      "Lanhas",
      "Loureira",
      "Moure",
      "Oleiros",
      "Parada de Gatim",
      "Pico",
      "Ponte",
      "Prado (São Miguel)",
      "Sabariz",
      "Soutelo",
      "Turiz",
      "União das freguesias da Ribeira do Neiva",
      "União das freguesias de Carreiras (São Miguel) e Carreiras (Santiago)",
      "União das freguesias de Escariz (São Mamede) e Escariz (São Martinho)",
      "União das freguesias de Esqueiros, Nevogilde e Travassós",
      "União das freguesias de Marrancos e Arcozelo",
      "União das freguesias de Oriz (Santa Marinha) e Oriz (São Miguel)",
      "União das freguesias de Pico de Regalados, Gondiães e Mós",
      "União das freguesias de Sande, Vilarinho, Barros e Gomide",
      "União das freguesias de Valbom (São Pedro), Passô e Valbom (São Martinho)",
      "União das freguesias do Vade",
      "Valdreu",
      "Vila Verde e Barbudo",
      "Vila de Prado"
    ],
    "Vizela": [
      "Infias",
      "Santa Eulália",
      "Tagilde",
      "União das freguesias de Caldas de Vizela (São Miguel e São João)",
      "Vizela (Santo Adrião)",
      "Vizela (São Paio)"
    ]
  },
  "Bragança": {
    "Alfândega da Fé": [],
    "Bragança": [],
    "Carrazeda de Ansiães": [],
    "Freixo de Espada à Cinta": [],
    "Macedo de Cavaleiros": [],
    "Miranda do Douro": [],
    "Mirandela": [],
    "Mogadouro": [],
    "Torre de Moncorvo": [],
    "Vila Flor": [],
    "Vimioso": [],
    "Vinhais": []
  },
  "Castelo Branco": {
    "Belmonte": [],
    "Castelo Branco": [],
    "Covilhã": [],
    "Fundão": [],
    "Idanha-a-Nova": [],
    "Oleiros": [],
    "Penamacor": [],
    "Proença-a-Nova": [],
    "Sertã": [],
    "Vila Velha de Ródão": [],
    "Vila de Rei": []
  },
  "Coimbra": {
    "Arganil": [
      "Anseriz",
      "Arganil",
      "Benfeita",
      "Celavisa",
      "Folques",
      "Piódão",
      "Pombeiro da Beira",
      "Pomares",
      "Sarzedo",
      "Secarias",
      "São Martinho da Cortiça",
      "União das freguesias de Cepos e Teixeira",
      "União das freguesias de Cerdeira e Moura da Serra",
      "União das freguesias de Coja e Barril de Alva",
      "Vila Cova de Alva e São Roque"
    ],
    "Cantanhede": [
      "Ançã",
      "Cadima",
      "Cordinhã",
      "Covões e Camarneira",
      "Febres",
      "Murtede",
      "Ourentã",
      "Outil",
      "Sanguinheira",
      "São Caetano",
      "Sepins e Bolho",
      "Tocha",
      "União das freguesias de Cantanhede e Pocariça",
      "União das freguesias de Portunhos e Outil",
      "União das freguesias de Vilamar e Corticeiro de Cima"
    ],
    "Coimbra": [
      "Almalaguês",
      "Brasfemes",
      "Ceira",
      "Cernache",
      "Santo António dos Olivais",
      "São João do Campo",
      "São Silvestre",
      "Torres do Mondego",
      "União das freguesias de Antuzede e Vil de Matos",
      "União das freguesias de Assafarge e Antanhol",
      "União das freguesias de Coimbra (Sé Nova, Santa Cruz, Almedina e São Bartolomeu)",
      "União das freguesias de Eiras e São Paulo de Frades",
      "União das freguesias de Santa Clara e Castelo Viegas",
      "União das freguesias de Souselas e Botão",
      "União das freguesias de São Martinho de Árvore e Lamarosa",
      "União das freguesias de São Martinho do Bispo e Ribeira de Frades",
      "União das freguesias de Taveiro, Ameal e Arzila",
      "União das freguesias de Trouxemil e Torre de Vilela"
    ],
    "Condeixa-a-Nova": [
      "Anobra",
      "Ega",
      "Furadouro",
      "União das freguesias de Condeixa-a-Velha e Condeixa-a-Nova",
      "União das freguesias de Sebal e Belide",
      "União das freguesias de Vila Seca e Bem da Fé",
      "Zambujal"
    ],
    "Figueira da Foz": [
      "Alhadas",
      "Alqueidão",
      "Bom Sucesso",
      "Ferreira-a-Nova",
      "Lavos",
      "Maiorca",
      "Marinha das Ondas",
      "Moinhos da Gândara",
      "Paião",
      "Quiaios",
      "Tavarede",
      "Vila Verde",
      "União das freguesias de Buarcos e São Julião",
      "União das freguesias de Santana e Vila Verde",
      "União das freguesias de São Pedro e São Julião"
    ],
    "Góis": [
      "Alvares",
      "Cadafaz",
      "Colmeal",
      "Góis",
      "Vila Nova do Ceira"
    ],
    "Lousã": [
      "Foz de Arouce",
      "Gândaras",
      "Lousã",
      "Serpins",
      "Vilarinho",
      "União das freguesias de Lousã e Vilarinho"
    ],
    "Mira": [
      "Carapelhos",
      "Mira",
      "Praia de Mira",
      "Seixo"
    ],
    "Miranda do Corvo": [
      "Lamas",
      "Miranda do Corvo",
      "Rio de Vide",
      "Semide",
      "Vila Nova"
    ],
    "Montemor-o-Velho": [
      "Arazede",
      "Carapinheira",
      "Ereira",
      "Liceia",
      "Meãs do Campo",
      "Pereira",
      "Santo Varão",
      "Seixo de Gatões",
      "Tentúgal",
      "Verride",
      "União das freguesias de Abrunheira, Verride e Vila Nova da Barca",
      "União das freguesias de Montemor-o-Velho e Gatões"
    ],
    "Oliveira do Hospital": [
      "Aldeia das Dez",
      "Alvoco das Várzeas",
      "Avô",
      "Bobadela",
      "Ervedal",
      "Lagares",
      "Lourosa",
      "Meruge",
      "Nogueira do Cravo",
      "Santa Ovaia",
      "Seixo da Beira",
      "São Gião",
      "Travanca de Lagos",
      "União das freguesias de Lagos da Beira e Lajeosa",
      "União das freguesias de Oliveira do Hospital e São Paio de Gramaços",
      "União das freguesias de Penalva de Alva e São Sebastião da Feira"
    ],
    "Pampilhosa da Serra": [
      "Cabril",
      "Dornelas do Zêzere",
      "Fajão",
      "Pampilhosa da Serra",
      "Portela do Fojo",
      "Unhais-o-Velho",
      "União das freguesias de Janeiro de Cima e Vidual",
      "União das freguesias de Pessegueiro e Machio"
    ],
    "Penacova": [
      "Carvalho",
      "Figueira de Lorvão",
      "Lorvão",
      "Penacova",
      "Sazes do Lorvão",
      "São Paio de Mondego",
      "União das freguesias de Friúmes e Paradela",
      "União das freguesias de Oliveira do Mondego e Travanca do Mondego",
      "União das freguesias de São Pedro de Alva e São Paio de Mondego"
    ],
    "Penela": [
      "Cumeeira",
      "Espinhal",
      "São Miguel",
      "União das freguesias de Penela (Santa Eufémia) e São Miguel",
      "União das freguesias de Rabaçal"
    ],
    "Soure": [
      "Alfarelos",
      "Brunhós",
      "Degracias",
      "Figueiró do Campo",
      "Granja do Ulmeiro",
      "Pombalinho",
      "Samuel",
      "Soure",
      "Tapéus",
      "Vila Nova de Anços",
      "Vinha da Rainha",
      "União das freguesias de Brunhós e Vinha da Rainha",
      "União das freguesias de Degracias e Pombalinho"
    ],
    "Tábua": [
      "Ázere",
      "Carapinha",
      "Espariz",
      "Midões",
      "Mouronho",
      "Sinde",
      "Tábua",
      "Tonda",
      "União das freguesias de Covas e Vila Nova de Oliveirinha",
      "União das freguesias de Pinheiro de Coja e Meda de Mouros",
      "União das freguesias de Póvoa de Midões"
    ],
    "Vila Nova de Poiares": [
      "Arrifana",
      "Lavegadas",
      "Poiares (Santo André)",
      "São Miguel de Poiares"
    ]
  },
  "Faro": {
    "Albufeira": [
      "Albufeira e Olhos de Água",
      "Ferreiras",
      "Guia",
      "Paderne"
    ],
    "Alcoutim": [
      "Alcoutim e Pereiro",
      "Giões",
      "Martim Longo",
      "Vaqueiros"
    ],
    "Aljezur": [
      "Aljezur",
      "Bordeira",
      "Odeceixe",
      "Rogil"
    ],
    "Castro Marim": [
      "Altura",
      "Azinhal",
      "Castro Marim",
      "Odeleite"
    ],
    "Faro": [
      "Conceição e Estoi",
      "Montenegro",
      "Santa Bárbara de Nexe",
      "União das freguesias de Faro (Sé e São Pedro)"
    ],
    "Lagoa": [
      "Carvoeiro",
      "Estômbar e Parchal",
      "Ferragudo",
      "Lagoa e Carvoeiro",
      "Porches"
    ],
    "Lagos": [
      "Bensafrim e Barão de São João",
      "Luz",
      "Odiáxere",
      "União das freguesias de Lagos (São Sebastião e Santa Maria)"
    ],
    "Loulé": [
      "Alte",
      "Almancil",
      "Ameixial",
      "Boliqueime",
      "Quarteira",
      "Salir",
      "São Clemente",
      "São Sebastião",
      "Tôr",
      "União das freguesias de Querença, Tôr e Benafim"
    ],
    "Monchique": [
      "Alferce",
      "Marmelete",
      "Monchique"
    ],
    "Olhão": [
      "Moncarapacho e Fuseta",
      "Olhão",
      "Pechão",
      "Quelfes"
    ],
    "Portimão": [
      "Alvor",
      "Mexilhoeira Grande",
      "Portimão"
    ],
    "Silves": [
      "Alcantarilha e Pêra",
      "Algoz e Tunes",
      "Armação de Pêra",
      "São Bartolomeu de Messines",
      "São Marcos da Serra",
      "Silves"
    ],
    "São Brás de Alportel": [
      "São Brás de Alportel"
    ],
    "Tavira": [
      "Cabanas de Tavira",
      "Conceição e Cabanas de Tavira",
      "Luz de Tavira e Santo Estêvão",
      "Santa Catarina da Fonte do Bispo",
      "Santiago",
      "Santa Maria",
      "Tavira (Santa Maria e Santiago)"
    ],
    "Vila Real de Santo António": [
      "Monte Gordo",
      "Vila Nova de Cacela",
      "Vila Real de Santo António"
    ],
    "Vila do Bispo": [
      "Barão de São Miguel",
      "Budens",
      "Raposeira",
      "Sagres",
      "Vila do Bispo"
    ]
  },
  "Guarda": {
    "Aguiar da Beira": [],
    "Almeida": [],
    "Celorico da Beira": [],
    "Figueira de Castelo Rodrigo": [],
    "Fornos de Algodres": [],
    "Gouveia": [],
    "Guarda": [],
    "Manteigas": [],
    "Mêda": [],
    "Pinhel": [],
    "Sabugal": [],
    "Seia": [],
    "Trancoso": [],
    "Vila Nova de Foz Côa": []
  },
  "Leiria": {
    "Alcobaça": [
      "Aljubarrota",
      "Alpedriz",
      "Bárrio",
      "Benedita",
      "Cela",
      "Cós",
      "Évora de Alcobaça",
      "Maiorga",
      "Pataias",
      "São Martinho do Porto",
      "Turquel",
      "Vimeiro",
      "União das freguesias de Alcobaça e Vestiaria",
      "União das freguesias de Coz, Alpedriz e Montes",
      "União das freguesias de Prazeres de Aljubarrota",
      "União das freguesias de São Vicente de Aljubarrota e Prazeres"
    ],
    "Alvaiázere": [
      "Alvaiázere",
      "Almoster",
      "Maçãs de Dona Maria",
      "Pelmá",
      "Pussos São Pedro",
      "Rego da Murta"
    ],
    "Ansião": [
      "Alvorge",
      "Ansião",
      "Avelar",
      "Chão de Couce",
      "Pousaflores",
      "Santiago da Guarda",
      "Torre de Vale de Todos"
    ],
    "Batalha": [
      "Batalha",
      "Reguengo do Fetal",
      "São Mamede",
      "União das freguesias de Golpilheira"
    ],
    "Bombarral": [
      "Bombarral",
      "Carvalhal",
      "Pó",
      "Roliça",
      "União das freguesias de Vale Côvo"
    ],
    "Caldas da Rainha": [
      "A dos Francos",
      "Alvorninha",
      "Carvalhal Benfeito",
      "Foz do Arelho",
      "Landal",
      "Nadadouro",
      "Salir de Matos",
      "Salir do Porto",
      "Santa Catarina",
      "São Gregório",
      "Tornada",
      "Vidais",
      "União das freguesias de Caldas da Rainha (Nossa Senhora do Pópulo, Coto e São Gregório)",
      "União das freguesias de Caldas da Rainha (Santo Onofre e Serra do Bouro)"
    ],
    "Castanheira de Pera": [
      "Castanheira de Pera",
      "Coentral"
    ],
    "Figueiró dos Vinhos": [
      "Aguda",
      "Arega",
      "Bairradas",
      "Campelo",
      "Figueiró dos Vinhos"
    ],
    "Leiria": [
      "Bajouca",
      "Bidoeira de Cima",
      "Caranguejeira",
      "Coimbrão",
      "Colmeias",
      "Maceira",
      "Memória",
      "Milagres",
      "Monte Real",
      "Monte Redondo",
      "Regueira de Pontes",
      "Santa Catarina da Serra",
      "Santa Eufémia",
      "União das freguesias de Leiria, Pousos, Barreira e Cortes",
      "União das freguesias de Marrazes e Barosa",
      "União das freguesias de Parceiros e Azoia",
      "União das freguesias de Souto da Carpalhosa e Ortigosa"
    ],
    "Marinha Grande": [
      "Marinha Grande",
      "Moita",
      "Vieira de Leiria"
    ],
    "Nazaré": [
      "Famalicão",
      "Nazaré",
      "Valado dos Frades"
    ],
    "Pedrógão Grande": [
      "Graça",
      "Pedrógão Grande",
      "Vila Facaia"
    ],
    "Peniche": [
      "Atouguia da Baleia",
      "Ferrel",
      "Peniche",
      "Serra d'El-Rei"
    ],
    "Pombal": [
      "Abiul",
      "Almagreira",
      "Carnide",
      "Carriço",
      "Louriçal",
      "Mata Mourisca",
      "Pelariga",
      "Pombal",
      "Redinha",
      "Vermoil",
      "Vila Cã",
      "União das freguesias de Guia, Ilha e Mata Mourisca",
      "União das freguesias de Santiago de Litém, São Simão de Litém e Albergaria dos Doze"
    ],
    "Porto de Mós": [
      "Alqueidão da Serra",
      "Alvados",
      "Calvaria de Cima",
      "Mira de Aire",
      "Pedreiras",
      "São Bento",
      "Serro Ventoso",
      "União das freguesias de Porto de Mós (São João Baptista e São Pedro)",
      "União das freguesias de Juncal e Alqueidão da Serra"
    ],
    "Óbidos": [
      "Amoreira",
      "Gaeiras",
      "Olho Marinho",
      "Santa Maria",
      "São Pedro",
      "Sobral da Lagoa",
      "União das freguesias de A-dos-Negros",
      "Usseira",
      "Vau"
    ]
  },
  "Lisboa": {
    "Alenquer": [],
    "Amadora": [],
    "Arruda dos Vinhos": [],
    "Azambuja": [],
    "Cadaval": [],
    "Cascais": [],
    "Lisboa": [],
    "Loures": [],
    "Lourinhã": [],
    "Mafra": [],
    "Odivelas": [],
    "Oeiras": [],
    "Sintra": [],
    "Sobral de Monte Agraço": [],
    "Torres Vedras": [],
    "Vila Franca de Xira": []
  },
  "Madeira": {
    "Calheta (Madeira)": [],
    "Câmara de Lobos": [],
    "Funchal": [],
    "Machico": [],
    "Ponta do Sol": [],
    "Porto Moniz": [],
    "Porto Santo": [],
    "Ribeira Brava": [],
    "Santa Cruz": [],
    "Santana": [],
    "São Vicente": []
  },
  "Portalegre": {
    "Alter do Chão": [],
    "Arronches": [],
    "Avis": [],
    "Campo Maior": [],
    "Castelo de Vide": [],
    "Crato": [],
    "Elvas": [],
    "Fronteira": [],
    "Gavião": [],
    "Marvão": [],
    "Monforte": [],
    "Nisa": [],
    "Ponte de Sor": [],
    "Portalegre": [],
    "Sousel": []
  },
  "Porto": {
    "Amarante": [],
    "Baião": [],
    "Felgueiras": [],
    "Gondomar": [],
    "Lousada": [],
    "Maia": [],
    "Marco de Canaveses": [],
    "Matosinhos": [],
    "Paredes": [],
    "Paços de Ferreira": [],
    "Penafiel": [],
    "Porto": [],
    "Póvoa de Varzim": [],
    "Santo Tirso": [],
    "Trofa": [],
    "Valongo": [],
    "Vila Nova de Gaia": [],
    "Vila do Conde": []
  },
  "Santarém": {
    "Abrantes": [],
    "Alcanena": [],
    "Almeirim": [],
    "Alpiarça": [],
    "Benavente": [],
    "Cartaxo": [],
    "Chamusca": [],
    "Constância": [],
    "Coruche": [],
    "Entroncamento": [],
    "Ferreira do Zêzere": [],
    "Golegã": [],
    "Mação": [],
    "Ourém": [],
    "Rio Maior": [],
    "Salvaterra de Magos": [],
    "Santarém": [],
    "Sardoal": [],
    "Tomar": [],
    "Torres Novas": [],
    "Vila Nova da Barquinha": []
  },
  "Setúbal": {
    "Alcochete": [],
    "Alcácer do Sal": [],
    "Almada": [],
    "Barreiro": [],
    "Grândola": [],
    "Moita": [],
    "Montijo": [],
    "Palmela": [],
    "Santiago do Cacém": [],
    "Seixal": [],
    "Sesimbra": [],
    "Setúbal": [],
    "Sines": []
  },
  "Viana do Castelo": {
    "Arcos de Valdevez": [],
    "Caminha": [],
    "Melgaço": [],
    "Monção": [],
    "Paredes de Coura": [],
    "Ponte da Barca": [],
    "Ponte de Lima": [],
    "Valença": [],
    "Viana do Castelo": [],
    "Vila Nova de Cerveira": []
  },
  "Vila Real": {
    "Alijó": [],
    "Boticas": [],
    "Chaves": [],
    "Mesão Frio": [],
    "Mondim de Basto": [],
    "Montalegre": [],
    "Murça": [],
    "Peso da Régua": [],
    "Ribeira de Pena": [],
    "Sabrosa": [],
    "Santa Marta de Penaguião": [],
    "Valpaços": [],
    "Vila Pouca de Aguiar": [],
    "Vila Real": []
  },
  "Viseu": {
    "Armamar": [],
    "Carregal do Sal": [],
    "Castro Daire": [],
    "Cinfães": [],
    "Lamego": [],
    "Mangualde": [],
    "Moimenta da Beira": [],
    "Mortágua": [],
    "Nelas": [],
    "Oliveira de Frades": [],
    "Penalva do Castelo": [],
    "Penedono": [],
    "Resende": [],
    "Santa Comba Dão": [],
    "Sernancelhe": [],
    "Sátão": [],
    "São João da Pesqueira": [],
    "São Pedro do Sul": [],
    "Tabuaço": [],
    "Tarouca": [],
    "Tondela": [],
    "Vila Nova de Paiva": [],
    "Viseu": [],
    "Vouzela": []
  },
  "Évora": {
    "Alandroal": [],
    "Arraiolos": [],
    "Borba": [],
    "Estremoz": [],
    "Montemor-o-Novo": [],
    "Mora": [],
    "Mourão": [],
    "Portel": [],
    "Redondo": [],
    "Reguengos de Monsaraz": [],
    "Vendas Novas": [],
    "Viana do Alentejo": [],
    "Vila Viçosa": [],
    "Évora": []
  }
};

// Lista plana de distritos
export const DISTRITOS = Object.keys(LOC_PT).sort();

// Atalhos rápidos para Coimbra e arredores (zona principal de actuação)
export const ZONAS_RAPIDAS = [
  { label: "Coimbra Centro", distrito: "Coimbra", concelho: "Coimbra", freguesia: "União das freguesias de Coimbra (Sé Nova, Santa Cruz, Almedina e São Bartolomeu)" },
  { label: "Coimbra (todos)", distrito: "Coimbra", concelho: "Coimbra", freguesia: "" },
  { label: "Condeixa-a-Nova", distrito: "Coimbra", concelho: "Condeixa-a-Nova", freguesia: "" },
  { label: "Figueira da Foz", distrito: "Coimbra", concelho: "Figueira da Foz", freguesia: "" },
  { label: "Lousã", distrito: "Coimbra", concelho: "Lousã", freguesia: "" },
  { label: "Montemor-o-Velho", distrito: "Coimbra", concelho: "Montemor-o-Velho", freguesia: "" },
  { label: "Penacova", distrito: "Coimbra", concelho: "Penacova", freguesia: "" },
  { label: "Soure", distrito: "Coimbra", concelho: "Soure", freguesia: "" },
  { label: "Mira", distrito: "Coimbra", concelho: "Mira", freguesia: "" },
  { label: "Cantanhede", distrito: "Coimbra", concelho: "Cantanhede", freguesia: "" },
];

export function freguesiasDe(distrito, concelho) {
  return LOC_PT[distrito]?.[concelho] || [];
}
export function concelhosDe(distrito) {
  return distrito && LOC_PT[distrito] ? Object.keys(LOC_PT[distrito]).sort() : [];
}
